export default __webpack_public_path__ + "static/media/web-dev.26513561.svg";